import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function sanitizeAndValidateInput(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value) return null;

        // Detectar etiquetas HTML o contenido malicioso
        const hasHTMLTags = /<.*?>/.test(value);
        const hasMaliciousChars = /[<>();'"]/g.test(value);

        const sqlKeywords = /\b(SELECT|INSERT|UPDATE|DELETE|DROP|TRUNCATE|ALTER|CREATE|EXEC|UNION|--|#|\*\*|\/\*|\*\*\/)\b/gi;
        const hasSQLInjection = sqlKeywords.test(value);

        if (hasHTMLTags || hasMaliciousChars || hasSQLInjection) {
            return {
                sanitize: {
                    hasHTMLTags,
                    hasMaliciousChars,
                    hasSQLInjection,
                },
            };
        }

        return null;
    };
}
